<template>
  <div class="mr-1 uploaded-image thumbnail has-background-primary-light" >
    <img v-if="imageUrl" :src="imageUrl" alt="Asset" class=""/>
    <div v-else class="is-flex align-items-center justify-center">
      <q-r-code-icon style="margin: 1px 0 0 1px" color="has-text-cool-blue-text" :size="16"/>
    </div>
  </div>
</template>

<script>
import QRCodeIcon from "@/components/ui/icons/QRCodeIcon.vue";

export default {

  components: {QRCodeIcon},

  props: {
    imageUrl: {
      type: String,
      required: false,
      default: null
    },
  },
}
</script>

<style>
.thumbnail {
  width: 45px;
  height: 45px;
  border-radius: 50%;
}
</style>